/** Base URL de la API. Vite: VITE_API_URL; Docker/GHCR aún pueden inyectar REACT_APP_API_URL. */
export const API_URL =
  import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || 'http://localhost:5124';
